import script from "./UserWallet.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserWallet.vue?vue&type=script&lang=ts&setup=true"

import "./UserWallet.vue?vue&type=style&index=0&id=504bfd30&lang=scss"

const __exports__ = script;

export default __exports__